import React, { useEffect, useState } from "react";
import FilterCatDetails from "../CategoryDetails/FilterCatDetails";
import CheckIDVerifyList from "./CheckIDVerifyList";
import DateRangeComponent from "../../../reuseableComponents/DateRangeComponent";
import { useAuthDetails } from "../../../Common/cookiesHelper";
import { useDispatch } from "react-redux";
import { fetchCheckIDVerifyData } from "../../../Redux/features/Reports/CheckIDVerify/CheckIDVerifySlice";

const CheckIDVerifyMain = ({ setExportFilters, setExportAvailable, setExportHeaders, setCSVData, setCSVHeaders }) => {
  const dispatch = useDispatch();
  const { LoginGetDashBoardRecordJson, userTypeData } = useAuthDetails();
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(false);

  const orderEnv = (type) => {
    if (type === "Online Order") return "Online";
    if (type === "Store Order") return "Offline";
    return type || "";
  };
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const handleDateRangeChange = (dateRange) => {
    setSelectedDateRange(dateRange);
    setPage(1);
    setHasMore(true);
    if (typeof setExportAvailable === 'function') {
      setExportAvailable(false);
    }
  };

  const [OrderSourceData, setOrderSourceData] = useState(null);
  const [OrderTypeData, setOrderTypeData] = useState(null);
  const [SelectCatData, setSelectCatData] = useState(null);

  const handleFilterDataChange = (OrderSource, OrderType, SelectCat) => {
    setOrderSourceData(OrderSource);
    setOrderTypeData(OrderType);
    setSelectCatData(SelectCat);
    setPage(1);
    setHasMore(true);
  };

  const fetchCheckIDVerifyDataWithPagination = async (currentPage) => {
    if (!selectedDateRange) return;

    // Only show initial loading for page 1, pagination loading for page > 1
    if (currentPage === 1) {
      setInitialLoading(true);
    } else {
      setIsLoading(true);
    }

    try {
      const data = {
        merchant_id: LoginGetDashBoardRecordJson?.data?.merchant_id,
        start_date: selectedDateRange.start_date,
        end_date: selectedDateRange.end_date,
        order_typ: OrderTypeData,
        order_env: orderEnv(OrderSourceData),
        page: currentPage,
        limit: 12,
        ...userTypeData,
      };

      const response = await dispatch(fetchCheckIDVerifyData(data)).unwrap();

      // Check if we got less than limit, meaning no more data
      if (!response || response.length < 12) {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching Check ID Verify data:", error);
      setHasMore(false);
    } finally {
      setIsLoading(false);
      setInitialLoading(false);
    }
  };

  const handleInitialFetch = () => {
    setPage(1);
    setHasMore(true);
    fetchCheckIDVerifyDataWithPagination(1);
  };

  const fetchMoreData = () => {
    if (!hasMore || isLoading) return;
    const nextPage = page + 1;
    setPage(nextPage);
    fetchCheckIDVerifyDataWithPagination(nextPage);
  };

  // Keep export filters in sync with the latest selected range (and future filter additions)
  useEffect(() => {
    if (!selectedDateRange) return;
    if (typeof setExportFilters === 'function') {
      setExportFilters({
        start_date: selectedDateRange?.start_date,
        end_date: selectedDateRange?.end_date,
        search_by: selectedDateRange?.search_by,
        selected_report: "id-verification",
        order_typ: OrderTypeData ?? "",
        order_env: orderEnv(OrderSourceData),
      });
    }
  }, [
    selectedDateRange?.start_date,
    selectedDateRange?.end_date,
    selectedDateRange?.search_by,
    OrderTypeData,
    OrderSourceData,
  ]);

  return (
    <>
      {/* <div className="q-order-main-page">
        <FilterCatDetails
          onFilterDataChange={handleFilterDataChange}
          title={"Check ID Verification Report"}
          showcat={"0"}
        />
      </div> */}
      <div className="q-attributes-main-page">
        <div className="box">
          <DateRangeComponent onDateRangeChange={handleDateRangeChange} />
        </div>
      </div>
      <div className="mt-10">
        <div className="q-attributes-main-page">
          <CheckIDVerifyList
            selectedDateRange={selectedDateRange}
            OrderSourceData={OrderSourceData}
            OrderTypeData={OrderTypeData}
            SelectCatData={SelectCatData}
            setCSVData={setCSVData}
            setCSVHeaders={setCSVHeaders}
            setExportHeaders={setExportHeaders}
            setExportAvailable={setExportAvailable}
            page={page}
            hasMore={hasMore}
            fetchMoreData={fetchMoreData}
            isLoading={isLoading}
            initialLoading={initialLoading}
            onInitialFetch={handleInitialFetch}
          />
        </div>
      </div>
    </>
  );
};

export default CheckIDVerifyMain;